export enum MovementType {
  FrontLegsKicking = 'FrontLegsKicking',
  BackLegsKicking = 'BackLegsKicking',
  HeadMovement = 'HeadMovement',
  NeedsShoulderHeldDown = 'NeedsShoulderHeldDown',
}
